const isPortrait = () => {
  return window?.innerHeight > window?.innerWidth;
};

export const isMobile = () => {
  const userAgent = navigator.userAgent;
  const mobileKeywords = [
    'Android',
    'iPhone',
    'iPod',
    'BlackBerry',
    'Windows Phone',
    'Opera Mini',
    'IEMobile',
  ];
  return mobileKeywords.some((keyword) => userAgent.includes(keyword));
};

export const isMobileInPortrait = () => {
  return isMobile() && isPortrait();
};

export const isMobileInLandscape = () => {
  return isMobile() && !isPortrait();
};
